import { useMemo } from "react";
import { useSelector } from "react-redux";
import useUserAuthentication from "../../_hooks/useUserAuthentication";
import { OrganizationType } from "../../_statics/OrganizationType";

export const useUserDropdownUtils = () => {
    const clientReducer = useSelector((state) => state.client);
    const user = useSelector((state) => state.authentication.user);
    const { isSuperUser, isInAgency, selectedOrganization } = useUserAuthentication();

    const isTaxAgency = useMemo(
        () =>
            user &&
            user.selectedOrganization &&
            user.selectedOrganization.organizationType === OrganizationType.TAX_AGENCY,
        [user]
    );

    const userDropdownItems = useMemo(() => {
        let items = [
            {
                name: "Administration",
                url: "/adminarea",
                dataCy: "user-admin-button",
                icon: "fas fa-user-tie",
                hidden: !(isSuperUser || isInAgency),
                index: 1,
            },
            {
                name: "Account und Abrechnung",
                url: "/organization",
                dataCy: "user-company-button",
                icon: "fas fa-building",
                index: 3,
            },
            {
                name:
                    "API Verbindungen" +
                    (clientReducer && clientReducer.clients ? ` (${clientReducer.clients.length})` : ""),
                url: "/clients",
                dataCy: "user-clients-button",
                icon: "fas fa-plug-circle-bolt",
                hidden: isTaxAgency,
                index: 4,
            },
            {
                name: "Logout",
                url: "/dologout",
                dataCy: "logout-button",
                icon: "fas fa-lock",
                index: 5,
            },
        ];

        if (selectedOrganization) {
            items.push({
                name: `Administration (${selectedOrganization.name})`,
                url: `/adminarea/organization/${selectedOrganization.externalUUID}`,
                dataCy: "user-admin-button",
                icon: "fas fa-user-tie",
                hidden: !(isSuperUser || isInAgency),
                index: 2,
            });
        }

        return items;
    }, [clientReducer, isInAgency, isSuperUser, selectedOrganization]);

    return {
        userDropdownItems,
    };
};
